import { createContext, useContext, useEffect, useState } from 'react';
import { useJobContext } from '../hooks/Jobs';

const RespuestaContext = createContext();

export const RespuestaProvider = ({ children }) => {
  const [respuesta, setRespuesta] = useState(null);
  const { wsProject, etapa, isCompleted, tipoEstructura } = useJobContext();  

  const setRespuestaData = (data) => {
    setRespuesta(data);
  };

  const createRespuestaData = (data) => {
    console.log("createRespuestaData", data);
    
    //desestructuramos la respuesta del proyecto capturado por websockets
    const { modelo, formato, propuestas, id, Titulo_ST, Story_Telling } = data;

    // Factory function handle para diferentes tiposEstructura
    const getPropuestasData = (tipoEstructura, etapa, propuestas) => {
        switch (tipoEstructura) {
            case 'unidad_activa':
                return handleUnidadActiva(etapa, propuestas);
            default:
                return handleDefault(propuestas);
        }
    };

    const handleUnidadActiva = (etapa, propuestas) => {
      console.log("handleUnidadActiva propuestas", propuestas);
      const props = [propuestas];      
      return props;
    };

    const handleDefault = (propuestas) => {
        return Object.values(propuestas);
    };

    // Factoria funcion para obteneter la respuesta
    const propuestasData = getPropuestasData(tipoEstructura, etapa, propuestas);

    console.log("propuestasData", propuestasData);

     //Construimos un objeto respuesta
    const objRespuesta = {
        id,
        modelo,
        formato,
        propuestas: propuestasData
    };

    if(Titulo_ST && Story_Telling){
      objRespuesta.Titulo_ST = Titulo_ST;
      objRespuesta.Story_Telling = Story_Telling;
    }

    console.log("objRespuesta transformado", objRespuesta);

    // Actualizamos el state
    setRespuesta(objRespuesta);
};



   //Reaccionamos si hay un cambio en proyectos y etapa
   useEffect(() => {
    const resp = () => {
        if (Object.keys(wsProject).length != 0 && isCompleted) {                
            console.log(`useRespuesta wsProject=${wsProject} etapa=${etapa} isCompleted=${isCompleted}`);
            console.log("cargando data useEffecto useRespuesta", wsProject);
            createRespuestaData(wsProject);            
        }
    }
    
    resp();
}, [wsProject, etapa, isCompleted])


  return (
    <RespuestaContext.Provider value={{ respuesta, setRespuestaData }}>
      {children}
    </RespuestaContext.Provider>
  );
};

export const useRespuesta = () => {
  return useContext(RespuestaContext);
};

